"use client"

import { StretchHorizontal } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `StretchHorizontalIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const StretchHorizontalIcon = component(Icon)({ as: StretchHorizontal })
